var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4998 3.41663C11.0698 3.41663 3.4165 11.07 3.4165 20.5C3.4165 29.93 11.0698 37.5833 20.4998 37.5833C29.9298 37.5833 37.5832 29.93 37.5832 20.5C37.5832 11.07 29.9298 3.41663 20.4998 3.41663ZM20.5 8.54161C23.3358 8.54161 25.625 10.8308 25.625 13.6666C25.625 16.5024 23.3358 18.7916 20.5 18.7916C17.6642 18.7916 15.375 16.5024 15.375 13.6666C15.375 10.8308 17.6642 8.54161 20.5 8.54161ZM20.5 32.7999C16.3774 32.8 12.5289 30.7346 10.25 27.2991C10.3012 23.8995 17.0833 22.0374 20.5 22.0374C23.8996 22.0374 30.6987 23.8995 30.75 27.2991C28.4711 30.7346 24.6226 32.8 20.5 32.7999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account-circle.d03ce6ba23b61d00e45734c65cdc32c3.svg";
export { ForwardRef as ReactComponent };